import { useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import pushPxDraft from '../../../../../api/pushPxDraft';
import { createBETool } from '../../../../../api/pushVisit';
import { setToastType, updateDraftId } from '../../../../../store/actions/prescriptionPad';
import { getPrescription } from '../../../../../store/selectors/prescriptionPad';

export const PushToCloudBt: React.FC = () => {
    const px = useSelector(getPrescription);
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const pushToCloud = () => {
        if (!px) {
            return;
        }

        const toolObj = {
            allMilestones: px.allMilestones,
            allVaccines: px.allVaccines,
            ...createBETool(px),
        };

        setLoading(true);
        pushPxDraft(px.id, px.visitId, toolObj).then((r) => {
            batch(() => {
                if (r.success && r.draftId) {
                    dispatch(updateDraftId(r.draftId));
                    dispatch(setToastType('push-success'));
                    setLoading(false);
                }
            });
        });
    };
    return (
        <button
            onClick={pushToCloud}
            className="btn--small inline-flex items-center focus:outline-none font-700 border-b border-dotted border-white text-white py-2"
        >
            {isLoading ? (
                <svg
                    className="w-16 h-16 fill-white animate-spin"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                </svg>
            ) : (
                <svg
                    className="w-16 h-16 fill-white"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                >
                    <path d="M543.3 214.5C543.5 212.3 544 210.2 544 208C544 146.1 493.9 96 432 96c-11.41 0-22.19 2.207-32.56 5.377C368.9 59.51 319.8 32 264 32C170.8 32 95.41 107.9 96.08 200.8C40.24 220.6 0 273.4 0 336C0 415.5 64.47 480 144 480h360c75.11 0 136-60.89 136-136C640 282.7 599.1 231.4 543.3 214.5zM504 432H144c-52.94 0-96-43.07-96-96c0-40.2 25.77-76.36 64.13-89.97l32.19-11.42c-.2734-38.62-.2246-33.15-.293-37.17C145.4 132.4 198.7 80 264 80c38.4 0 73.63 18.1 96.66 49.67l20.14 27.6l32.67-9.988c48.86-14.94 84.23 25.56 81.96 64.4l-2.193 37.72l36.15 10.99C566.8 271.8 592 305.4 592 344C592 392.5 552.5 432 504 432zM336.1 175c-2.211-2.211-4.863-3.961-7.797-5.178c-5.867-2.43-12.48-2.43-18.34 0C307.9 171.1 305.2 172.8 303 175l-88 88c-9.375 9.375-9.375 24.56 0 33.94s24.56 9.375 33.94 0L296 249.9V376c0 13.25 10.75 24 24 24s24-10.75 24-24V249.9l47.03 47.03C395.7 301.7 401.8 304 408 304s12.28-2.344 16.97-7.031c9.375-9.375 9.375-24.56 0-33.94L336.1 175z"></path>
                </svg>
            )}
            <span className="pl-8 flex items-baseline">
                {isLoading ? 'Pushing Updates' : ' Push Updates'}
            </span>
        </button>
    );
};
